<template>
    <div>
        <MercenaryHeader :title="'오늘의 활동량'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex:1; padding:0px 12px; padding-top:20px; background-color: #f5f5f5;">
            <div class="title">오늘의 활동량</div>
            <div class="alarm_container">
                <div style="flex:1;">
                    <div class="alarm_container_title">만보기</div>
                    <div class="alarm_container_explanation">걸음수로 오늘의 활동량을 측정합니다</div>
                </div>
                <div style="display:grid; place-items: center;">
                    <CustomSwitchFilter v-model="settings.home_pedometer_show" style="" :click-action="() => { saveSettings('home_pedometer_show') }" :isBold="true" />
                </div>
            </div>
            <div style="font-size:12px; font-weight:500; color:#210F03; margin-top:10px;">만보기 설정을 해제하면 '오늘의 활동량'을 볼 수 없게 됩니다.</div>
        </div>
    </div>

</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import CustomSwitchFilter from "../../common/CustomSwitchFilter";
    import ResponseCode from "../../../ResponseCode";
    export default {
        name: "TodayActivity",
        components: {CustomSwitchFilter, MercenaryHeader},
        data(){
            return {
                settings: {
                    home_pedometer_show: false,
                },
            }
        },
        methods : {
            async getSettings() {
                const parameters = {};
                const res = await this.$Axios.get('/api/setting/mine', { params: parameters });

                const settings = {}

                for (const each in res.data.setting) {
                    settings[each] = res.data.setting[each] == '1'
                }

                console.log(settings);
                this.settings = settings;

            },
            async saveSettings(key) {
                setTimeout(async () => {
                    const parameters = {};
                    parameters[key] = this.settings[key] ? '1' : '0';
                    const res = await this.$Axios.post('/api/setting/save', parameters);
                    if (res.data.code === ResponseCode.FAIL) {
                        this.$GlobalStore.showAlert(res.data.msg);
                    }
                }, 50);

            }
        },
        created(){
            this.getSettings();
        }
    }
</script>

<style scoped>
    .title {
        color: #210F03;
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 500;
    }

    .alarm_container {
        background-color: white;
        border-radius: 12px;
        padding: 15px 12px;
        display: flex;
    }

    .horizontal_line {
        height: 1px;
        background-color: #EBEBEB;
        margin: 10px 0px;
    }

    .container {
        background-color: white;
        border-radius: 12px;
        padding: 15px 12px;
    }

    .container_title {
        color: #210F03;
        font-size: 14px;
        font-weight: 500;
    }

    .container_btn {
        color: var(--color-main);
        font-size: 14px;
        font-weight: 500;
    }

    .alarm_container_color1 {
        background-color: #F5F5F5;
    }

    .alarm_container_title {
        font-size: 14px;
        color: #210f03;
        font-weight: bold;
    }

    .alarm_container_explanation {
        font-size: 12px;
        color: #210f03;
        margin-top: 5px;
        line-height: 18px;
    }

    .alarm_container+.alarm_container {
        margin-top: 10px;
    }

    .alarm_container_explanation_sub {
        color: #808080;
        font-size: 12px;
        line-height: 18px;
    }

    .switch_wrap {
        padding-left: 10px;
    }
</style>